export default [
    {
        // [0]
        key: "name",
        label: app.$i18n.t("Employee"),
        sortable: true,
        visible: true,
    },
    {
        // [1]
        key: "isSchedule",
        label: app.$i18n.t("Schedule"),
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
    {
        // [1]
        key: "total_attendance",
        label: app.$i18n.t("Attendances"),
        thClass: "text-center",
        tdClass: "text-center",
        sortable: true,
        visible: true,
    },
    {
        // [1]
        key: "count_is_late",
        label: app.$i18n.t("Tardiness"),
        thClass: "text-center",
        tdClass: "text-center",
        sortable: true,
        visible: true,
    },
    {
        // [1]
        key: "count_absence",
        label: app.$i18n.t("Absences"),
        thClass: "text-center",
        tdClass: "text-center",
        sortable: true,
        visible: true,
    },
    {
        // [1]
        key: "count_inconsistency",
        label: app.$i18n.t("Inconsistency Days"),
        thClass: "text-center",
        tdClass: "text-center",
        sortable: true,
        visible: true,
    },
]